export default "__VITE_ASSET__D39fMWu2__"